import { Injectable } from '@angular/core';
import { HttpClientService } from '../implementacion/http-client.service';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { ObjDel } from 'src/app/models/SiicartAdm/ObjDel.model';


@Injectable({ providedIn: 'root' })
  export class empresaService {

    constructor( private http: HttpClientService ) { }

    ObtenerEmpresas() {
      return this.http.get(`${environment.apiScar}Empresa/ObtenerEmpresas`)
        .pipe(map(response => response));
    }
    AgrModfEmpresa(Unidad: any) {
      return this.http.post(`${environment.apiScar}Empresa/AgregarModificaEmpresa`, Unidad)
        .pipe(map(response => response));
    }

    EliminarEmpresa(ids: ObjDel) {
      return this.http.post(`${environment.apiScar}Empresa/EliminarEmpresas`, ids)
      .pipe(map(response => response));
    }

}